import type {z} from "zod";

import {EditServiceNoteBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editServiceNoteFormSchema = zod.object({
  title: requiredStringSchema(EditServiceNoteBody.shape.title, noteFieldLabelIds.title),
  content: requiredStringSchema(EditServiceNoteBody.shape.content, noteFieldLabelIds.content),
});
export type EditServiceNoteFormPayload = z.output<typeof editServiceNoteFormSchema>;

export const draftEditServiceNoteFormSchema = editServiceNoteFormSchema.partial();
export type DraftEditServiceNoteFormPayload = z.output<typeof draftEditServiceNoteFormSchema>;
